import { useTranslation } from 'react-i18next';
import { CHAIN_ICONS } from '@/lib/constants';
import type { CrossChainRoute } from '@/lib/query-options';
import { cn } from '@/lib/utils';
import MingcuteArrowRightLine from '~icons/mingcute/arrow-right-line';
import MingcuteReceiveMoneyLine from '~icons/mingcute/receive-money-line';
import MingcuteTransferVerticalLine from '~icons/mingcute/transfer-vertical-line';
import MingcuteWallet from '~icons/mingcute/wallet-line';

interface TransferInfoProps {
  receiver: string;
  fromAddress: string;
  className?: string;
  amount?: string;
  recive: string;
  route: CrossChainRoute;
}

export function TransferInfo({
  receiver,
  fromAddress,
  className,
  recive,
  route,
}: TransferInfoProps) {
  const { t } = useTranslation();
  return (
    <div
      className={cn(
        'bg-foreground/2 ring-1 ring-foreground/5 backdrop-blur-md rounded-md p-3 space-y-2',
        className,
      )}
    >
      <h4 className="font-anta text-sm text-foreground/80">
        {t('transfer.transferInfo')}
      </h4>

      <div className="grid grid-cols-[auto_1fr] gap-x-2 gap-y-2 items-start text-xs">
        <div className="flex items-center space-x-1 text-foreground/60">
          <MingcuteWallet className="size-4" />
          <span>{t('common.from')}:</span>
        </div>
        <p className="break-words break-all font-mono min-w-0">
          {fromAddress || <span className="text-foreground/40">-</span>}
        </p>

        <div className="flex items-center space-x-1 text-foreground/60">
          <MingcuteWallet className="size-4" />
          <span>{t('common.to')}:</span>
        </div>
        <p className="break-words break-all font-mono min-w-0">
          {receiver || <span className="text-foreground/40">-</span>}
        </p>

        <div className="flex items-center space-x-1 text-foreground/60">
          <MingcuteTransferVerticalLine className="size-4" />
          <span>{t('transfer.transferPath')}:</span>
        </div>
        <div className="break-words font-inter flex items-center space-x-2">
          <div className="flex items-center space-x-2">
            <img
              src={CHAIN_ICONS[route.fromChain]}
              alt={route.fromChain}
              className="size-4 ring-1 ring-foreground/10 rounded-full"
            />
            <span>{route.fromChain}</span>
          </div>
          <MingcuteArrowRightLine className="size-4 text-foreground/40" />
          <div className="flex items-center space-x-2">
            <img
              src={CHAIN_ICONS[route.toChain]}
              alt={route.toChain}
              className="size-4 ring-1 ring-foreground/10 rounded-full"
            />
            <span>{route.toChain}</span>
          </div>
        </div>

        <div className="flex items-center space-x-1 text-foreground/60">
          <MingcuteReceiveMoneyLine className="size-4" />
          <span>{t('transfer.youReceive')}:</span>
        </div>
        <p className="break-words font-pt-mono">
          <span className="text-foreground/40 mr-1 inline-block translate-y-[calc(1em/11)]">
            ≈
          </span>
          <span className="text-green-700">{recive}</span>
          <span className="font-sans leading-tight text-foreground/40 ml-1">
            USDT
          </span>
        </p>
      </div>
    </div>
  );
}


